
import React from "react";

import { Card, Row,Col } from "antd";

function KoganError({error}){


    const formatKoganError = () => {

        const msg = error.message;
        const data = error.response.data;
        const status = error.response.status;
    
        return data?.body?.errors.map(err=>{
            return  <Col span={24} >
                <div><span>`SKU: {err.product_sku} has following errors:` </span></div>
                <div><span>`{JSON.stringify(err.errors)}` </span></div>
            </Col>;
        });
        
           
    };
    
    const getTitle=()=>{
        return   error.response.data.status?error.response.data.status:error.message;
    }

    return (
        <Row justify={'center'}>
            <Col span={24}><strong>{getTitle()}</strong></Col>
            {formatKoganError()}
            </Row>
    

    );
}

export default KoganError;